import { Flex, Skeleton } from '@kognitos/lattice';

export const AOPSkeleton = () => {
  return (
    <Flex
      direction="column"
      gap={3}
      width="full"
      height="full"
      data-testid="aop-skeleton"
    >
      <Skeleton className="h-6 w-4/12" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-6/12" />
      <Skeleton className="h-6 w-4/12 mt-5" />
      <Flex gap={2} width="full">
        <Skeleton className="size-4 ml-4" />
        <Skeleton className="h-4 w-10/12" />
      </Flex>
      <Flex gap={2} width="full">
        <Skeleton className="size-4 ml-4" />
        <Skeleton className="h-4 w-7/12" />
      </Flex>
      <Flex gap={2} width="full">
        <Skeleton className="size-4 ml-4" />
        <Skeleton className="h-4 w-9/12" />
      </Flex>
      <Flex gap={2} width="full">
        <Skeleton className="size-4 ml-4" />
        <Skeleton className="h-4 w-8/12" />
      </Flex>
      <Flex gap={2} width="full">
        <Skeleton className="size-4 ml-4" />
        <Skeleton className="h-4 w-10/12" />
      </Flex>
    </Flex>
  );
};
